<template>
    <a-form :form="form" @submit.prevent="handleSubmit">
        <a-row :gutter="16">
            <a-col :span="12">
                <a-form-item :label="$t('modules.displayName')">
                    <a-input v-model="form.displayName" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item :label="$t('modules.icon')">
                    <MaterialIconPicker v-model="form.icon" />
                </a-form-item>
            </a-col>
        </a-row>

        <a-form-item :label="$t('modules.description')">
            <a-textarea v-model="form.description" :rows="4" />
        </a-form-item>

        <a-form-item>
            <a-radio-group v-model="form.relation.type" button-style="solid">
                <a-radio-button value="table-to-table">{{ $t("modules.relationPairTableTable") }}</a-radio-button>
                <a-radio-button value="table-to-standart" style="display: none;">{{ $t("modules.relationPairTableStandart") }}</a-radio-button>
                <a-radio-button value="standart-to-table">{{ $t("modules.relationPairStandartTable") }}</a-radio-button>
            </a-radio-group>
        </a-form-item>

        <template v-if="form.relation.type === 'table-to-table'">
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-card :title="$t('modules.fromColumn')">
                        <TableConnectionForm v-model="form.relation.tableToTable.from" :tables="tables" />
                    </a-card>
                </a-col>
                <a-col :span="12">
                    <a-card :title="$t('modules.toColumn')">
                        <TableConnectionForm v-model="form.relation.tableToTable.to" :tables="tables" />
                    </a-card>
                </a-col>
            </a-row>
        </template>

        <template v-if="form.relation.type === 'table-to-standart'">
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-card :title="$t('modules.fromColumn')">
                        <TableConnectionForm v-model="form.relation.tableToStandart.from" :tables="tables" />
                    </a-card>
                </a-col>
                <a-col :span="12">
                    <a-card :title="$t('modules.toColumn')">
                        <StandartModuleConnectionForm
                            v-model="form.relation.tableToStandart.to"
                            :contact-properties="contactProperties"
                        />
                    </a-card>
                </a-col>
            </a-row>
        </template>

        <template v-if="form.relation.type === 'standart-to-table'">
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-card :title="$t('modules.fromColumn')">
                        <StandartModuleConnectionForm
                            v-model="form.relation.standartToTable.from"
                            :contact-properties="contactProperties"
                        />
                    </a-card>
                </a-col>
                <a-col :span="12">
                    <a-card :title="$t('modules.toColumn')">
                        <TableConnectionForm v-model="form.relation.standartToTable.to" :tables="tables" />
                    </a-card>
                </a-col>
            </a-row>
        </template>
    </a-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MaterialIconPicker from "../Module/MaterialIconPicker.vue";
import TableConnectionForm from "./components/TableConnectionForm.vue";
import StandartModuleConnectionForm from "./components/StandartModuleConnectionForm.vue";

export default {
    components: {
        MaterialIconPicker,
        TableConnectionForm,
        StandartModuleConnectionForm,
    },
    props: {
        module: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: {
                displayName: "",
                description: "",
                icon: "",
                relation: {
                    type: "table-to-table",
                    tableToTable: {
                        from: {
                            table: null,
                            connectionType: "_id",
                            field: null,
                        },
                        to: {
                            table: null,
                            connectionType: "_id",
                            field: null,
                        },
                    },
                    tableToStandart: {
                        from: {
                            table: null,
                            connectionType: "field",
                            field: null,
                        },
                        to: {
                            module: "contact",
                            connectionType: "field",
                            field: "_id",
                        },
                    },
                    standartToTable: {
                        from: {
                            module: "contact",
                            connectionType: "field",
                            field: "_id",
                        },
                        to: {
                            table: null,
                            connectionType: "_id",
                            field: null,
                        },
                    },
                },
            },
        };
    },
    created() {
        this.initForm();
    },
    computed: {
        ...mapState({
            tables: (state) => state.table.tables,
            contactProperties: (state) => state.contactProperty.data,
        }),
    },
    methods: {
        ...mapActions({
            updateModule: "module/updateModule",
            syncModules: "module/syncModules",
        }),
        initForm() {
            this.form.displayName = this.module.displayName || "";
            this.form.description = this.module.description || "";
            this.form.icon = this.module.icon || "";
            
            if (this.module.relation) {
                this.form.relation.type = this.module.relation.type || "table-to-table";
                
                if (this.module.relation.tableToTable) {
                    this.form.relation.tableToTable = JSON.parse(JSON.stringify(this.module.relation.tableToTable));
                }
                
                if (this.module.relation.tableToStandart) {
                    this.form.relation.tableToStandart = JSON.parse(JSON.stringify(this.module.relation.tableToStandart));
                }
                
                if (this.module.relation.standartToTable) {
                    this.form.relation.standartToTable = JSON.parse(JSON.stringify(this.module.relation.standartToTable));
                }
            }
        },
        async handleSubmit() {
            try {
                const updatingFields = {
                    displayName: this.form.displayName,
                    description: this.form.description,
                    icon: this.form.icon,
                };
                
                // İlişki tipini ekle
                updatingFields["relation.type"] = this.form.relation.type;
                
                // İlişki tipine göre ilgili alanları düzleştirerek ekle
                if (this.form.relation.type === "table-to-table") {
                    updatingFields["relation.tableToTable.from.table"] = this.form.relation.tableToTable.from.table;
                    updatingFields["relation.tableToTable.from.connectionType"] = this.form.relation.tableToTable.from.connectionType;
                    
                    if (this.form.relation.tableToTable.from.connectionType === "field") {
                        updatingFields["relation.tableToTable.from.field"] = this.form.relation.tableToTable.from.field;
                    }
                    
                    updatingFields["relation.tableToTable.to.table"] = this.form.relation.tableToTable.to.table;
                    updatingFields["relation.tableToTable.to.connectionType"] = this.form.relation.tableToTable.to.connectionType;
                    
                    if (this.form.relation.tableToTable.to.connectionType === "field") {
                        updatingFields["relation.tableToTable.to.field"] = this.form.relation.tableToTable.to.field;
                    }
                } 
                else if (this.form.relation.type === "table-to-standart") {
                    updatingFields["relation.tableToStandart.from.table"] = this.form.relation.tableToStandart.from.table;
                    updatingFields["relation.tableToStandart.from.connectionType"] = this.form.relation.tableToStandart.from.connectionType;
                    updatingFields["relation.tableToStandart.from.field"] = this.form.relation.tableToStandart.from.field;
                    
                    updatingFields["relation.tableToStandart.to.module"] = this.form.relation.tableToStandart.to.module;
                    updatingFields["relation.tableToStandart.to.connectionType"] = this.form.relation.tableToStandart.to.connectionType;
                    updatingFields["relation.tableToStandart.to.field"] = this.form.relation.tableToStandart.to.field;
                } 
                else if (this.form.relation.type === "standart-to-table") {
                    updatingFields["relation.standartToTable.from.module"] = this.form.relation.standartToTable.from.module;
                    updatingFields["relation.standartToTable.from.connectionType"] = this.form.relation.standartToTable.from.connectionType;
                    updatingFields["relation.standartToTable.from.field"] = this.form.relation.standartToTable.from.field;
                    
                    updatingFields["relation.standartToTable.to.table"] = this.form.relation.standartToTable.to.table;
                    updatingFields["relation.standartToTable.to.connectionType"] = this.form.relation.standartToTable.to.connectionType;
                    
                    if (this.form.relation.standartToTable.to.connectionType === "field") {
                        updatingFields["relation.standartToTable.to.field"] = this.form.relation.standartToTable.to.field;
                    }
                }
                
                await this.updateModule({
                    moduleName: this.module.moduleName,
                    updatingFields,
                });
                
                this.$message.success(this.$t("modules.updateSuccess"));
                this.$emit("success");
                this.syncModules();
            } catch (error) {
                this.$message.error(this.$t("modules.updateFailed"));
            }
        },
    },
    watch: {
        module: {
            handler() {
                this.initForm();
            },
            deep: true,
        },
    },
};
</script> 